import MaskAPI from './ids-mask-api';

const maskAPI = new MaskAPI();

export default maskAPI;
